// imports
import Model from '$dependencies/Model';
// private static properties
export const FIELDS = {
    uuid: { type: String, default: '', identifier: true },
    name: { type: String, default: '' },
    title: { type: String, default: '' },
    label: { type: String, default: '' },
	parent: { type: String, default: '' },
	value: { type: String, default: '' },
};

// class definition
export default class TagModel extends Model {
    // constructor
    constructor(args = {}) {
        // clone args to do some modifications
        args = Object.assign({}, args);
        args.fields = FIELDS;
        // call super constructor
        super(args);
    }

    // methods
	parse(data) {
		this.set(data.data);
		this.label = this.title;
		this.value = this.uuid;
	}

    destroy() {

	}
}
